module.exports = __webpack_public_path__ + "assets/webgl/ticket_verso_DE_L0.7bd986b7.jpg";